import { useEffect, useState } from 'react';

import configService from '../services/configService';

import useScript from './useScript';

const key = configService.getKeyGooglMaps();

export default function usePlacesService(componentId: string) {
  const [scriptLoaded] = useScript(
    `//maps.googleapis.com/maps/api/js?key=${key}&libraries=places`,
    'google-maps-script',
  );
  const [service, setService] = useState();
  const googleScript: any = document.getElementById('google-maps-script');
  const googleService = (window as any).google;

  useEffect(() => {
    if (scriptLoaded && googleScript && googleService) {
      const mapsDiv = document.createElement('div');
      mapsDiv.setAttribute('id', componentId);
      const placesService = new googleService.maps.places.PlacesService(mapsDiv);
      setService(placesService);
    }
  }, [scriptLoaded, googleScript, googleService, componentId]);

  return [service];
}
